import { __decorate, __metadata } from "tslib";
import { Mutation, 
// Action,
VuexModule, Module } from 'vuex-module-decorators';
let pscmCompModule = class pscmCompModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.successPop = false;
        this.successDelete = false;
        this.errorPop = {
            show: false,
            description: []
        };
    }
    get getSuccessPop() {
        return this.successPop;
    }
    get getErrorPop() {
        return this.errorPop;
    }
    get geSuccesDelete() {
        return this.successDelete;
    }
    ['setSuccessPop'](data) {
        this.successPop = data;
    }
    ['setErrorPop'](data) {
        this.errorPop = data;
    }
    ['setSuccessDelete'](data) {
        this.successDelete = data;
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], pscmCompModule.prototype, 'setSuccessPop', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], pscmCompModule.prototype, 'setErrorPop', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], pscmCompModule.prototype, 'setSuccessDelete', null);
pscmCompModule = __decorate([
    Module
], pscmCompModule);
export default pscmCompModule;
